import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { ThemeProvider as MaterialThemeProvider } from "@mui/material";
import { light } from "aviary-tokens/themes";
import type { AviaryTheme } from "aviary-tokens/themes";
import type { FC, ReactNode } from "react";
import { useState } from "react";

import { SnackWrap } from "../components/Snackbar";
import { Toaster } from "../components/Toast";

import { AviaryGlobalStyles } from "./AviaryGlobalStyles";
import * as styles from "./materialTheme";

interface Props {
  /*
   * Toggles a white background instead of muted blue
   */
  isWhiteBackground?: boolean;
  /**
   * Basically the rest of the app
   *
   * @default undefined
   */
  children?: ReactNode;
  /*
   * Disables normalization (ONLY FOR USE WITHIN ADMIN)
   * SERIOUSLY, THIS PAINS ME TO ADD
   * Only pigeons can use this
   */
  noNormalization?: boolean;
}

const AviaryProvider: FC<Props> = ({ isWhiteBackground, noNormalization, children }) => {
  // TODO: remove this comment when theme switching is implemented
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentTheme, setTheme] = useState<AviaryTheme>(light);

  /* NOTE: Material Theme provider must be rendered FIRST, as it
   * also utilizes emotion to theme itself. If this is not done,
   * theming breaks during runtime in some MUI elements
   *
   * Documentation can be found under the interoperability on MUI:
   * https://mui.com/material-ui/guides/interoperability/#theme
   */
  return (
    <MaterialThemeProvider theme={styles.datePickerTheme}>
      <EmotionThemeProvider theme={currentTheme}>
        <AviaryGlobalStyles
          isWhiteBackground={isWhiteBackground}
          noNormalization={noNormalization}
        />
        <SnackWrap>
          <Toaster>
            <>{children}</>
          </Toaster>
        </SnackWrap>
      </EmotionThemeProvider>
    </MaterialThemeProvider>
  );
};

export { AviaryProvider };
